import { useFind } from 'api/APIHooks';

export const useFindSocialCareCoverages = (personId, feeScheduleId) => {
  const { data: insurancesData, isSuccess } = useFind(
    'insurance',
    {
      person: personId,
      state: 'active,pending,inactive',
      'plan.plan_type': 'social',
      'plan.fee_schedules': feeScheduleId,
    },
    { queryConfig: { placeholderData: undefined, enabled: !!(personId && feeScheduleId) } },
  );
  const socialCareCoverages = insurancesData?.data?.data ?? [];

  return { socialCareCoverages, isSuccess };
};
